import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import React, { useEffect } from 'react';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import { ExpandMore } from '@mui/icons-material';

const HubspotForm: React.FC = () => {
	useEffect(() => {
		if (window.hbspt) {
			window.hbspt.forms.create({
				portalId: '5125893',
				formId: '55ddc9de-6f95-4a53-b107-e0c653caa356',
				region: 'na1',
				target: '#hubspotForm'
			});
		}
	}, []);

	const accordionStyle = {
		margin: '16px auto 0 auto',
		'&:before':{
			display: 'none',
		},
		'&.Mui-expanded': {
			margin: '16px auto 0 auto'
		}
	};

	return (
		<>
			<Box sx={{ width: '100%', maxWidth: '550px', margin: '0 auto', animationDelay: '1s' }} className='animate__animated animate__fadeIn'>
				{/* <div
					style={{
						textAlign: 'right',
						position: 'relative',
						top: '0.5em',
						right: '0.5em',
						zIndex: '2',
					}}
				>
				</div><Accordion sx={accordionStyle}>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<span style={{ marginRight: '16px', }}><ConnectWithoutContactIcon></ConnectWithoutContactIcon></span>
						<span style={{ fontWeight: 700, fontSize: '16px', lineHeight: '28px', }}>Formulario de contacto</span>
					</AccordionSummary>
					<AccordionDetails> */}
				<div id="hubspotForm"></div>
				{/* </AccordionDetails>
				</Accordion>*/}
			</Box> 
		</>
	);
};

export default HubspotForm;